import {ApolloError} from '@apollo/client';
import Alert from '@material-ui/lab/Alert';

type Props = {
  message?: string;
  error: ApolloError;
};

function ErrorBoundary(props: Props) {
  const {message, error} = props;

  if (error.networkError)
    return <Alert severity="error">{error.networkError.message}</Alert>;

  return (
    <>
      {/* <span>Hello</span> */}
      <Alert severity="error">{message || error.message}</Alert>
    </>
  );
}

ErrorBoundary.defaultProps = {
  message: null,
};

export default ErrorBoundary;
